import React, { useState } from "react";
import { Link } from "gatsby";
import MobileNavigation from "./Navigation/MobileNavigation";
import FullNavigation from "./Navigation/FullNavigation";

const isBrowser = () => typeof window !== "undefined";

const navigation = [
  {
    name: "Products",
    href: undefined,
    menu: true,
    menuItems: [
      {
        name: "Reeddi Capsule",
        desc: "Provides clean renewable 24/7",
        img: "/navbar/reeddi_menu.png",
        href: "/reeddi-capsule",
      },
      {
        name: "Rental Marketplace",
        desc: "Own anything temporarily",
        img: "/navbar/tempown_menu.png",
        href: "http://tempown.com/",
      },
    ],
  },
  { name: "About", href: "/about", menu: false },
  { name: "Contact", href: "#contact", menu: false },
  {
    name: "Learn",
    href: undefined,
    menu: true,
    menuItems: [
      {
        name: "How to rent the capsule",
        href: "/rent-a-capsule",
      },
      // {
      //   name: "How to buy the capsule",
      //   href: undefined,
      //   disabled: true,
      // },
    ],
  },
  { name: "Media", href: "/media", menu: false },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div
      className={`${
        mobileOpen ? "bg-[white]" : "cstm-bg-green-gradient"
      } w-full z-30 absolute`}
    >
      <div className="w-11/12 max-w-7xl mx-auto">
        <div className="relative flex items-center justify-end sm:justify-between h-16">
          <div className="flex-1 flex items-center justify-between sm:items-stretch">
            <Link
              to="/"
              className="absolute inset-y-0 left-0 flex-shrink-0 flex items-center no-click-highlight"
            >
              <img
                className="block w-auto no-click-highlight"
                src="/reeddi.svg"
                alt="Workflow"
              />
            </Link>
            <FullNavigation
              isBrowser={isBrowser}
              navigation={navigation}
              classNames={classNames}
            />
          </div>
          <div className="sm:hidden">
            {/* Mobile menu button*/}
            <MobileNavigation
              open={mobileOpen}
              setOpen={setMobileOpen}
              isBrowser={isBrowser}
              navigation={navigation}
              classNames={classNames}
            />
            {/* Mobile menu*/}
          </div>
        </div>
      </div>
    </div>
  );
}
